<ion-header>
  <ion-toolbar style="padding: 0 16px">
    <h3 *ngIf="automation?.name">Run "{{ automation.name }}"?</h3>
  </ion-toolbar>
</ion-header>

<div *ngIf="inputFields?.length">
  <app-response-input
    [responseInputFields]="inputFields"
    [showPublicOption]="false"
    layout="list"
  >
  </app-response-input>
</div>

<ion-footer class="footer ion-no-border">
  <ion-button (click)="submit()" [disabled]="isLoading">
    Start
    <ion-spinner
      name="crescent"
      [hidden]="!isLoading"
      style="margin-left: 10px"
    ></ion-spinner>
  </ion-button>
  <ion-button
    color="dark"
    fill="clear"
    (click)="dismiss()"
    [disabled]="isLoading"
    *ngIf="id"
  >
    Cancel
  </ion-button>
</ion-footer>
